import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import UserTable from '../../../components/tables/UserTable';

const generateSampleData = (count = 25) => {
  const statuses = ['Active', 'Inactive'];
  const regions = [
    'Maharashtra',
    'Delhi NCR',
    'Gujarat',
    'Karnataka',
    'Tamil Nadu',
    'West Bengal',
    'Uttar Pradesh',
    'Rajasthan'
  ];
  const cities = [
    'Mumbai',
    'Delhi',
    'Ahmedabad',
    'Bengaluru',
    'Chennai',
    'Kolkata',
    'Lucknow',
    'Jaipur',
    'Indore',
    'Surat'
  ];

  return Array.from({ length: count }, (_, index) => {
    const joinDate = new Date(
      2019 + Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1
    )
      .toISOString()
      .split('T')[0];

    return {
      id: `MDS${String(index + 1).padStart(4, '0')}`,
      name: `Master Distributor ${index + 1}`,
      email: `mdistributor${index + 1}@network.com`,
      phone: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      city: cities[Math.floor(Math.random() * cities.length)],
      region: regions[Math.floor(Math.random() * regions.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      joinDate
    };
  });
};

const UserManagementMasterDistributor = () => {
  const [masterDistributorData, setMasterDistributorData] = useState(() => generateSampleData());

  const handleDataChange = (updatedData) => {
    setMasterDistributorData(updatedData);
  };

  return (
    <Container fluid>
      <UserTable
        data={masterDistributorData}
        userRole="Master Distributor"
        onDataChange={handleDataChange}
        extraColumns={[
          {
            key: 'region',
            label: 'Region',
          },
        ]}
      />
    </Container>
  );
};

export default UserManagementMasterDistributor;


